import * as user from "modules/api/user-effects";
import * as diagnostic from "modules/api/diagnostic-effects";

export default {
  user,
  diagnostic
};



// WEBPACK FOOTER //
// ./src/modules/api/api.js